import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import AnnouncementPopup from './components/AnnouncementPopup';
import CustomCodeInjector from './components/CustomCodeInjector';
import Home from './pages/Home';
import About from './pages/About';
import PrincipalMessage from './pages/PrincipalMessage';
import WhyUs from './pages/WhyUs';
import Admission from './pages/Admission';
import Fees from './pages/Fees';
import GalleryPage from './pages/GalleryPage';
import GalleryDetail from './pages/GalleryDetail';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import Contact from './pages/Contact';
import DynamicPage from './pages/DynamicPage';
import CoreValues from './pages/CoreValues';
import OurPhilosophy from './pages/OurPhilosophy';
import Recognition from './pages/Recognition';
import Accreditation from './pages/Accreditation';
import IcseBoard from './pages/IcseBoard';
import Curriculum from './pages/Curriculum';
import InfrastructurePage from './pages/InfrastructurePage';
import StudentEngagementPage from './pages/StudentEngagementPage';
import OtherFacilitiesPage from './pages/OtherFacilitiesPage';
import OurProgrammesPage from './pages/OurProgrammesPage';
import FoundationalProgrammePage from './pages/FoundationalProgrammePage';
import PreparatoryProgrammePage from './pages/PreparatoryProgrammePage';
import ExposureCodingPage from './pages/ExposureCodingPage';
import ExtraCurriculumActivitiesPage from './pages/ExtraCurriculumActivitiesPage';
import JuniorSchoolProgrammePage from './pages/JuniorSchoolProgrammePage';
import MiddleSchoolProgrammePage from './pages/MiddleSchoolProgrammePage';
import SeniorSchoolProgrammePage from './pages/SeniorSchoolProgrammePage';
import JobApplicationForm from './pages/JobApplicationForm';
import MandatoryPublicDisclosure from './pages/MandatoryPublicDisclosure';
import PublicNotice from './pages/PublicNotice';
import PrivacyPolicy from './pages/PrivacyPolicy';
import StAndrewsGroup from './pages/StAndrewsGroup';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <AnnouncementPopup />
      <CustomCodeInjector />
      <main className="overflow-hidden">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/why-us" element={<WhyUs />} />
          <Route path="/principals-message" element={<PrincipalMessage />} />
          <Route path="/curriculum" element={<Curriculum />} />
          <Route path="/curriculum-and-infrastructure" element={<Navigate to="/curriculum" replace />} />
          <Route path="/extra-curricular-activities" element={<ExtraCurriculumActivitiesPage />} />
          <Route path="/extra-curriculum-activities" element={<Navigate to="/extra-curricular-activities" replace />} />
          <Route path="/other-facilities" element={<OtherFacilitiesPage />} />
          <Route path="/admission" element={<Admission />} />
          <Route path="/job-application-form" element={<JobApplicationForm />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/gallery/:slug" element={<GalleryDetail />} />
          <Route path="/article" element={<Blog />} />
          <Route path="/article/:slug" element={<BlogDetail />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/our-programmes" element={<OurProgrammesPage />} />
          <Route path="/foundational-programme" element={<FoundationalProgrammePage />} />
          <Route path="/preparatory-programme" element={<PreparatoryProgrammePage />} />
          <Route path="/junior-school-programme" element={<JuniorSchoolProgrammePage />} />
          <Route path="/middle-school-programme" element={<MiddleSchoolProgrammePage />} />
          <Route path="/senior-school-programme" element={<SeniorSchoolProgrammePage />} />
          <Route path="/accreditation" element={<Accreditation />} />
          <Route path="/icse-board" element={<IcseBoard />} />
          <Route path="/exposure-to-programming-and-coding-languages" element={<ExposureCodingPage />} />
          <Route path="/our-philosophy" element={<OurPhilosophy />} />
          <Route path="/recognition" element={<Recognition />} />
          <Route path="/awards" element={<Recognition />} />
          <Route path="/awards-and-recognitions" element={<Recognition />} />
          <Route path="/frontend/recognition" element={<Navigate to="/recognition" replace />} />
          <Route path="/infrastructure" element={<InfrastructurePage />} />
          <Route path="/student-engagement" element={<StudentEngagementPage />} />
          <Route path="/core-values" element={<CoreValues />} />
          <Route path="/fees" element={<Fees />} />
          <Route path="/about-standrews-group" element={<StAndrewsGroup />} />
          <Route path="/mandatory-public-disclosure" element={<MandatoryPublicDisclosure />} />
          <Route path="/public-notice" element={<PublicNotice />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/:slug" element={<DynamicPage />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default App;


